export default __webpack_public_path__ + "static/media/Webinar2.28f983b6.png";